import { FC } from 'react';
import { IconColor, IconProps } from '../types';

export const ArrowButtonIcon: FC<
  IconProps & {
    direction?: 'right' | 'left' | 'up' | 'down';
    gradient?: 'gold';
  }
> = ({
  width = 24,
  height = 24,
  fillColor = IconColor.TEXT_PRIMARY,
  direction = 'right',
  gradient,
  ...props
}) => {
  const color = gradient ? 'url(#paint0_linear_12376_97149)' : fillColor;
  const rotate =
    direction === 'left' ? 180 : direction === 'up' ? -90 : direction === 'down' ? 90 : 0;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotate}deg)` }}
      {...props}
    >
      <path
        d="M14 18L12.6 16.55L16.15 13H4V11H16.15L12.6 7.45L14 6L20 12L14 18Z"
        fill={color}
      />

      <defs>
        <linearGradient
          id="paint0_linear_12376_97149"
          y1="8"
          x1="3.32812"
          y2="8"
          x2="20.6614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D38B24" />
          <stop offset="0.0720001" stopColor="#DFB066" />
          <stop offset="0.152" stopColor="#EDDEA5" />
          <stop offset="0.242" stopColor="#F3C962" />
          <stop offset="0.347" stopColor="#FAD682" />
          <stop offset="0.485" stopColor="#FFE8B2" />
          <stop offset="0.652" stopColor="#D99D51" />
          <stop offset="0.802" stopColor="#D69C4D" />
          <stop offset="1" stopColor="#F0DFA7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
